import { SVGProps } from 'react';

const BackIcon = (props: SVGProps<SVGSVGElement>) => {
    const { width, height, fill } = props;

    return (
        <svg
            width={width || 18}
            height={height || 18}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M15 8.25H5.872l4.193-4.192L9 3 3 9l6 6 1.057-1.057L5.872 9.75H15v-1.5Z"
                fill={fill || 'rgba(0, 0, 0, 0.87)'}
            />
        </svg>
    );
};

export default BackIcon;
